<style scoped>
@media (min-width: 62em){
    .eyvPXm {
        flex-direction: row;
        gap: 1.5rem;
    }
}
.eyvPXm {
    width: 100%;
    margin: auto;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
}
@media (min-width: 62em){
    .cOrWKb {
        gap: 1.5rem;
        max-width: 95%;
        margin-top: 10px
    }
}
.cOrWKb {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 20px
}
.bDkRnC {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 4px 16px 0px;
    border: none;
    background-color: rgb(255, 255, 255);
    border-radius: 16px;
    color: rgb(51, 51, 51);
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1;
    height: 100%;
    cursor: pointer;
}
.bDkRnC::after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    z-index: -1;
    border-radius: 16px;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 8px 32px 0px;
    opacity: 0;
    transition: opacity 0.3s ease-in-out 0s;
}
.blogs a {
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
}
@media (min-width: 35.9375em){
    .eRaiZP {
        max-height: 320px;
        flex-direction: row;
    }
}
.eRaiZP {
    display: flex;
    max-height: 320px;
    flex-direction: row;
    border-radius: 16px;
    position: relative;
    overflow: hidden;
}
@media (min-width: 35.9375em){
    .kxbHPc {
        flex: 0 0 min(40%, 300px);
        position: relative;
    }
}
.kxbHPc {
    flex: 2 1 0%;
    margin-right: 0px;
    display: flex;
    flex-direction: column;
}
@media (min-width: 35.9375em){
    .bsxnHR {
        height: 100%;
        object-fit: cover;
        object-position: left center;
    }
}
.blogs img {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -moz-user-drag: none;
    max-width: 100%;
    height: 100%;
    vertical-align: middle;
    border-style: none;
}
@media (min-width: 35.9375em){
    .ewwZFP {
        text-align: left;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        -webkit-box-pack: justify;
        justify-content: space-between;
    }
}
.ewwZFP {
    flex: 3 1 0%;
    text-align: center;
    padding: 1rem 1.5rem;
}
@media (min-width: 62em){
    .bVuJvk {
        margin-bottom: 1rem;
    }
}
@media (min-width: 35.9375em){
    .bVuJvk {
        margin-bottom: 0.5rem;
    }
}
@media (min-width: 48em){
    .jbmVda {
        font-size: 1.5rem;
    }
}
.jbmVda {
    font-size: 1.5rem;
    line-height: 1.25;
    margin-bottom: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
@media (min-width: 73.125em){
    .hKpmgs {
        font-size: 1.125rem;
    }
}
.hKpmgs {
    font-size: 1.125rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
.blogs p {
    font-weight: 400;
    line-height: 24px;
    margin: 0 0 1rem;
    letter-spacing: 0;
}
.dTBJEb {
    color: rgb(34, 44, 155);
    background-color: transparent;
    border: none;
    padding: 0px;
}
@media (min-width: 62em){
    .gPlcJB {
        min-height: 40px;
    }
}
.gPlcJB {
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    text-align: center;
    gap: 0.5rem;
    font-size: 1rem;
    font-family: Poppins, sans-serif;
    font-weight: 500;
    line-height: 1;
    padding: 0.5rem 1rem;
    min-height: 40px;
    border-radius: 40px;
    cursor: pointer;
    text-transform: uppercase;
}

@media (min-width: 62em){
    .uGKdM{
        padding-top: 0px;
        flex: 0 0 30%;
        max-width: 30%;
    }
}
.uGKdM {
    padding-top: 2rem;
}
.cbUqlq {
    line-height: 1.5;
    font-size: 1.25rem;
    text-decoration: none;
}
.dqTBkN {
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 4px 16px 0px;
    border-radius: 16px;
}
.gCoFLX {
    padding-bottom: 1rem;
    line-height: 1.25;
    display: flex;
}
.cDJQaG.small {
    margin: 0px 10px 0px 0px;
}
.cDJQaG.small img {
    height: 40px;
    width: 50px;
    border-radius: 4px;
    object-fit: cover;
}
.hhVGAC {
    flex: 3 1 0%;
}
.cQUkRA {
    display: block;
    color: rgb(118, 118, 118);
    font-size: 11px;
}
.gcfudH {
    font-size: 14px;
}
@media (min-width: 48em){
    .klmGsQ {
        -webkit-box-pack: center;
        justify-content: center;
    }
}
.klmGsQ {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.Ooawq {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 4px 16px 0px;
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: 4px;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
}
.Ooawq.current {
    color: rgb(255, 255, 255);
    background-color: rgb(34, 44, 155);
}
</style>
<template>
    <section class="featured-categories-wrap blog-history">
        <div class="container d-flex">
            <div class="tab-content blogs">
                <div class="cOrWKb">
                    <a :href="blog.url" class="bDkRnC" v-for="blog in blogs" :key="blog.id" >
                        <div class="eRaiZP">
                            <div class="kxbHPc">
                                <img v-if="blog.image != null" width="463" height="348" :src="blog.image" :alt="blog.title" class="bsxnHR">
                                <img v-else width="463" height="348" src="/themes/storefront/public/images/image-placeholder.png" :alt="blog.title" class="bsxnHR">

                            </div>
                            <div class="ewwZFP">
                                <span class="bVuJvk">
                                    <font style="vertical-align: inherit;">{{ blog.date }}</font>
                                </span>
                                <h2 class="jbmVda">
                                    <font style="vertical-align: inherit;">{{ blog.title }}</font>
                                </h2>
                                <p class="hKpmgs" v-html="blog.description">
                                </p>
                                <button class="gPlcJB dTBJEb">
                                    <font style="vertical-align: inherit;">Leggi di più</font>
                                </button>
                            </div>
                        </div>
                    </a>

                    <!-- pagination -->
                    <div class="Blogsstyles__PageNumbers-sc-1wnlgxx-10 klmGsQ" v-if="links.length >= 10">

                        <div v-for="(link, index) in  links" :key="(index)">
                            <a href="javascript:void(0);"  class="Ooawq"  v-if="link.label === 'pagination.previous' && link.url != null" v-on:click.prevent="getblog(link.url)">‹</a>
                            <!-- <a href="javascript:void(0);"  class="Ooawq current"  v-else-if="link.label === 'pagination.previous' && link.url == null">‹</a> -->

                            <a href="javascript:void(0);"  class="Ooawq" v-else-if="link.active === false && link.label !== 'pagination.previous'  && link.label !== 'pagination.next'" v-on:click.prevent="getblog(link.url)">{{ link.label }}</a>
                            <a href="javascript:void(0);"  class="Ooawq current" v-else-if="link.label !== 'pagination.previous'  && link.label !== 'pagination.next'">{{ link.label }}</a>
                            <a href="javascript:void(0);"  class="Ooawq" v-if="link.label === 'pagination.next' && link.url != null" v-on:click.prevent="getblog(link.url)">›</a>
                            <!-- <a href="javascript:void(0);"  class="Ooawq current" v-else-if="link.label === 'pagination.next' && link.url == null">›</a> -->
                        </div>
                    </div>
                    <!-- pagination end -->
                </div>
            </div>

            <!-- recent blog posts -->
            <div class="uGKdM">
                <h3 class="cbUqlq">Recent Posts</h3>
                <div class="dqTBkN">
                    <div class="gCoFLX"  v-for="recentblog in recentBlogs" :key="recentblog.id" >
                        <div class="cDJQaG small">
                            <a :aria-label="recentblog.title" :href="recentblog.url">
                                <img v-if="recentblog.image != null" width="85" height="85" :src="recentblog.image" :alt="recentblog.title" loading="lazy">
                                <img v-else width="85" height="85" src="/themes/storefront/public/images/image-placeholder.png" :alt="recentblog.title" loading="lazy">
                            </a>
                        </div>
                        <div class="hhVGAC">
                            <span class="cQUkRA">{{ recentblog.date }}</span>
                            <strong class="gcfudH">
                                <a :href="recentblog.url">{{ recentblog.title }}</a>
                            </strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                blogs: [],
                recentBlogs: [],
                links: []
            };
        },
        mounted() {
            this.loading = true;
            this.getblog();
            $.ajax({
                method: "GET",
                url: '/it/getrecentblogposts',
                context: this
            }).then(async recentBlogs => {
                this.recentBlogs = recentBlogs.response;
            });
        },
        methods: {
            getblog: function (page = "/it/getblog") {
                $.ajax({
                    method: "GET",
                    url: page,
                    context: this
                }).then(async blogs => {
                    this.blogs = blogs.response.data;
                    this.links = blogs.response.links
                });
            }
        }
    };
</script>
